var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import { Textarea as ChakraTextarea, } from "@chakra-ui/react";
import { ColorScheme } from "../../core/constants";
import FormControl from "../FormControl";
/**
 * The Textarea component allows you to easily create multi-line text inputs.
 */
const Textarea = forwardRef((props, ref) => {
    const { className, variantColor, colorScheme, label, name, error, helper, size, wrapperStyle } = props, rest = __rest(props, ["className", "variantColor", "colorScheme", "label", "name", "error", "helper", "size", "wrapperStyle"]);
    const scheme = colorScheme !== null && colorScheme !== void 0 ? colorScheme : variantColor;
    return (React.createElement(FormControl, { name: name, label: label, error: error, helper: helper, size: size, css: wrapperStyle },
        React.createElement(ChakraTextarea, Object.assign({}, rest, { ref: ref, size: size, name: name, focusBorderColor: scheme && `${scheme}.500`, errorBorderColor: ColorScheme.error && `${ColorScheme.error}.500`, className: className, colorScheme: scheme }))));
});
Textarea.displayName = "Textarea";
export default Textarea;
//# sourceMappingURL=Textarea.js.map